module.exports = __webpack_public_path__ + "static/media/logout-variant.7c137195.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/logout-variant.svg
// module id = 1355
// module chunks = 0